export default __webpack_public_path__ + "static/B0081-509025c0bbe9e030d1acb632dee95d35.png";